import { makeApiCall, makeFormApiCall } from '../../../_common/api.utils';
import { FIN_API_URL } from '../../../const';

/*************** BANK TRANSACTION DETAILS ADD START *************** */
export const bankTransactionDetailsAdd = (addData: any) => {
	const data = {
		CreateTranscationEntryToken: addData,
	};
	const url = `${FIN_API_URL}CreateTranscationEntry`;
	return makeApiCall(url, data);
};
/*************** BANK TRANSACTION DETAILS ADD END *************** */

/*************** BANK TRANSACTION DETAILS UPDATE START *************** */
export const bankTransactionDetailsUpdate = (updateData: any) => {
	const data = {
		UpdateTransactionToken: updateData,
	};
	const url = `${FIN_API_URL}UpdateTranscationEntry`;
	return makeApiCall(url, data);
};
/*************** BANK TRANSACTION DETAILS UPDATE END *************** */

/*************** BANK TRANSACTION DETAILS GET START *************** */
export const bankTransactionListGet = (listData: any) => {
	const data = {
		GetCompanyTranscationEntryListToken: listData,
	};
	const url = `${FIN_API_URL}GetCompanyTransactions`;
	return makeApiCall(url, data);
};
/*************** BANK TRANSACTION DETAILS GET END *************** */

/*************** BANK TRANSACTION DETAILS FETCH START *************** */
export const bankTransactionDetailsFetch = (fetchData: any) => {
	const data = {
		FetchParticularTransactionToken: fetchData,
	};
	const url = `${FIN_API_URL}GetParticularBranchAccountList`;
	return makeApiCall(url, data);
};
/*************** BANK TRANSACTION DETAILS FETCH END *************** */

/*************** BANK TRANSACTION DETAILS DELETE START *************** */
export const bankTransactionDetailsDelete = (deleteData: any) => {
	const data = {
		DeleteTransactionToken: deleteData,
	};
	const url = `${FIN_API_URL}DeleteTransaction`;
	return makeApiCall(url, data);
};
/*************** BANK TRANSACTION DETAILS DELETE END *************** */

/*****************BANK TRANSACTION PAGE  EXCEL START *************** */
export const bankTransactionPageExcel = (listData: any) => {
	const params = new URLSearchParams();
	params.append('GetAllGroupOfficerReportExportToken', listData);
	const url = `${FIN_API_URL}/Excel/GroupOfficerReportWithToken.php`;

	return makeFormApiCall(url, params);
};
/*****************BANK TRANSACTION PAGE  EXCEL END *************** */

/*****************MODEL VALUES START *************** */
export const modelValues = (getData: any) => {
	const data = {
		GetModelValuesToken: getData,
	};
	const url = `${FIN_API_URL}GetValuesModal`;
	return makeApiCall(url, data);
};
/*****************MODEL VALUES END *************** */

/*****************MODEL VALUES START *************** */
export const checkBranchEodValues = (getData: any) => {
	const data = {
		GetParticularBranchEODListToken: getData,
	};
	const url = `${FIN_API_URL}CheckBranchEODDone`;
	return makeApiCall(url, data);
};
/*****************MODEL VALUES END *************** */

/*****************  START *************** */
export const UpdateTransactionValues = (getData: any) => {
	const data = {
		ApprovalUpdateCashTransactionToken: getData,
	};
	const url = `${FIN_API_URL}UpdateSelectedTranscationIsApprove`;
	return makeApiCall(url, data);
};
/*****************MODEL VALUES END *************** */
